import React from "react";

const BuildingHome = ({
  width = 64,
  height = 64,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="32"
        cy="32"
        r="31"
        fill="#2D96A7"
        fillOpacity="0.1"
        stroke="#2D96A7"
        strokeWidth="2"
      />
      <path
        d="M24.9337 40.0013H21.5337C19.627 40.0013 18.667 39.0413 18.667 37.1346V21.5347C18.667 19.628 19.627 18.668 21.5337 18.668H27.267C29.1737 18.668 30.1336 19.628 30.1336 21.5347V24.0013"
        stroke="#2D96A7"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.1602 27.2266V42.1067C39.1602 44.2534 38.0936 45.3333 35.9469 45.3333H28.1602C26.0136 45.3333 24.9336 44.2534 24.9336 42.1067V27.2266C24.9336 25.08 26.0136 24 28.1602 24H35.9469C38.0936 24 39.1602 25.08 39.1602 27.2266Z"
        stroke="#2D96A7"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.8672 24.0013V21.5347C33.8672 19.628 34.8271 18.668 36.7338 18.668H42.4671C44.3738 18.668 45.3338 19.628 45.3338 21.5347V37.1346C45.3338 39.0413 44.3738 40.0013 42.4671 40.0013H39.1605"
        stroke="#2D96A7"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.333 30.668H34.6663"
        stroke="#000929"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.333 34.668H34.6663"
        stroke="#000929"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32 45.332V41.332"
        stroke="#000929"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BuildingHome;
